// extracted by mini-css-extract-plugin
export default {"main-fixed":"sticky-menu_main-fixed__irmWa","header":"sticky-menu_header__RUa+h","item":"sticky-menu_item__LCti2","--active":"sticky-menu_--active__rrsvd"};